<template>
  <div class="home-box">
    <Breadcrumbs :title="pageTitle"></Breadcrumbs>
    <v-row align="center">
      <v-overlay :value="vuexloading" :opacity="1" :color="'#FFFFFF'">
        <v-progress-circular
          color="#FFB300"
          indeterminate
          size="64"
        ></v-progress-circular>
      </v-overlay>

      <div class="col-md-12 home-tabs-body">
        <ExpenseTypeTable></ExpenseTypeTable>
      </div>
    </v-row>
  </div>
</template>

<script>
import ExpenseTypeTable from "@/components/expenses/ExpenseTypeTable";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ExpenseTypeList",
  components: {
    Breadcrumbs,
    ExpenseTypeTable,
  },

  data: function() {
    return {
      role: localStorage.getItem("role") || null,
      errors: null,
      loading: false,
      pageTitle: "Expense Types",
    };
  },
  computed: {
    ...mapGetters({
      vuexloading: "loading",
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.$store.dispatch("settings/getCompanySettings");
  },
};
</script>
